export const tooltipPresets = (tokens) => {
    const { tooltip } = tokens.component;
    return {
        type: {
            light: {
                componentsProps: {
                    tooltip: {
                        sx: {
                            color: tooltip.color.value,
                            backgroundColor: tooltip.light.backgroundColor.value,
                        },
                    },
                    arrow: {
                        sx: {
                            "&:before": {
                                backgroundColor: tooltip.light.backgroundColor.value,
                            },
                        },
                    },
                },
            },
            dark: {
                componentsProps: {
                    tooltip: {
                        sx: {
                            backgroundColor: tooltip.dark.backgroundColor.value,
                            color: tooltip.dark.color.value,
                        },
                    },
                    arrow: {
                        sx: {
                            "&:before": {
                                backgroundColor: tooltip.dark.backgroundColor.value,
                            },
                        },
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=tooltip.js.map